function nextEntityNameGenerator(name: string, separator = ' ') {
    let match, lastMatch;
    const numberRegex = /[0-9]+/g;
    const nameArr = [...name];

    while ((match = numberRegex.exec(name)) !== null) {
        lastMatch = match;
    }

    if (!lastMatch) {
        nameArr.push(`${separator}2`);
    } else {
        const newNumber = [...`${parseInt(lastMatch[0]) + 1}`];
        nameArr.splice(lastMatch.index, lastMatch[0].length, ...newNumber);
    }

    return nameArr.join('');
}

export default nextEntityNameGenerator;
